export default "__VITE_ASSET__60688bb2__"